import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { getInvoices } from "../../../store/actions"
import { useDispatch, useSelector } from "react-redux"
const PaymentLayout = ({ date, plan, limitExceed }) => {

    return (
        <div className="payment-layout-container">
            {
                limitExceed ?
                    <div>Your transaction limit is about to exceed. Please upgrade to continue using our service!</div>
                    :
                    <div className="title">We couldn’t process your payment for <span className="bold">{plan} ({date})</span>. Please update your payment method to avoid any service interruptions.</div>

            }
            <Link to={limitExceed ? "/settings/pricing" : "/settings/billing-details?tab=billing-history"}>
                <button className="button-background">{limitExceed ? "Upgrade now" : "Make payment"}</button>

            </Link>

        </div>
    )
}
export default PaymentLayout